export default __webpack_public_path__ + "static/media/img_major02_2.f9dc106c.jpg";